@if (_active) {
  <kendo-window title="{{ _isNew ? 'Add new record' : 'Edit' }}" (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)">
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <div class="border_sections-new">
            <div class="k-block">
              <h2>Your Mobile Application</h2>
              <div class="right_buttons">
                <br />
                <div class="row bottom_buttons">
                  <div class="col-xs-12">
                    <button class="hidden-xs" kendoButton (click)="_onSave($event)">
                      <span><img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" /></span>Save
                      & Close
                    </button>
                    <button class="hidden-xs" kendoButton (click)="_onCancel()">
                      <span><img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span><span class="hidden-xs">Close</span>
                    </button>
                  </div>
                  <div class="col-xs-12 visible-xs">
                    <div class="xs_menue_list">
                      <!-- <button class="noborder_left z_10" kendoButton
                      (click)="showMyContainer=!showMyContainer">
                      <span><img [src]="'/assets/menu/'+ _theme +'/save-icon.svg'" /></span><span
                    class="hidden-xs">Save123</span>
                  </button> -->
                  <button class="z_10" kendoButton>
                    <span><img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span><span class="hidden-xs">Close</span>
                  </button>
                  <!-- <div class="drop_list_content" *ngIf="showMyContainer">
                  <button class="savencl" kendoButton (click)="_onSave($event)">
                    <span class="positionalspan"><img
                    [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" /></span>Save
                    & Close
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 special_col_padding">
    <div class="row">
      <div class="col-12">
        <div class="form-group special_style_formgroup">
          <label class="control-label newLabelStyle width-100">Select Group Name</label>
          <kendo-combobox #kendo_combo_Groupe_name class="bordered k-combobox margin-left-12"
            placeholder="Select Group Name"
            [data]="_mobileAppGroupsFiltered"
            [suggest]="true"
            [filterable]="true" (filterChange)="_handleMobileAppGroupsFilter($event)"
            (valueChange)="_loadTransactionsDD($event)"
            [textField]="'name'" [valueField]="'id'"
            formControlName="mobileAppGroup" required>
          </kendo-combobox>
        </div>
      </div>
      <div class="col-12">
        <div class="grayseparatorTwo"></div>
      </div>
    </div>
  </div>
  <div class="col-12 special_col_padding">
    <div class="row">
      <div class="col-12">
        <div class="form-group special_style_formgroup">
          <label class="control-label newLabelStyle width-100">
            Select a Stock
            Transaction
          </label>
          <kendo-combobox #transactions_combo class="bordered k-combobox margin-left-12"
            placeholder="Select a Stock Transaction" [data]="_transactionsFiltered"
            [suggest]="true" [filterable]="true"
            (filterChange)="_handleTransactionsFilter($event)" [textField]="'name'"
            (valueChange)="_loadFields($event)" [valueField]="'id'" formControlName="transaction"
            [(ngModel)]="_selectedTransactionId" required>
          </kendo-combobox>
        </div>
      </div>
      <div class="col-12">
        <div class="grayseparatorTwo"></div>
      </div>
    </div>
  </div>
  <div class="col-12 special_col_padding">
    <div class="row">
      <div class="col-12">
        <label class="control-label newLabelStyle width-100">Choose Fields to show on Items List</label>
        <p class="italicGrayText">
          Note : Add And Choose Mandatory Fields That You Need To Show In The
          Transaction.
        </p>
        <p class="italicGrayText">
          Drag And Drop The Selected Fields To Get The desired Order Of Fields.
        </p>
        <p class="italicGrayText">
          *Mandatory Fields Are Required and Will Be Automatically Added To The
          Selected Fields.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="row stepsRowMargin">
  <div class="col-12 col-md-6 stepsColPadding">
    <div class="row stepsRowMargin">
      <div class="col-6 stepsColPadding">
        <h2 class="listboxTitle listboxTitle_left">Available Field(s)</h2>
        <div class="bordered_sections_special_small bordered_sections_special_left minHeightSection leftListbox">
          <div class="buttonsAbsolutecontainer_left">
            <img class="" (click)="moveSelected('up','right')"
              [src]="'/assets/menu/'+ _theme +'/move-right-arrow.svg'" />
              <img class="" (click)="moveAll('right')"
                [src]="'/assets/menu/'+ _theme +'/move-all-right-arrow.svg'" />
                <img class="" (click)="moveSelected('down', 'left')"
                  [src]="'/assets/menu/'+ _theme +'/move-down-arrow.svg'" />
                  <img class="" (click)="moveSelected('up', 'left')"
                    [src]="'/assets/menu/'+ _theme +'/move-up-arrow.svg'" />
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <ul class="selectedFieldsArray">
                        @for (field of fields; track field; let i = $index) {
                          <li
                            (click)="toggleSelection(field, 1)"
                            [class.item-selected]="field.isSelected">
                            <span>{{field.title}}</span>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 stepsColPadding">
                <h2 class="listboxTitle listboxTitle_right">Selected Field(s)</h2>
                <div class="bordered_sections_special_small minHeightSection rightListbox">
                  <div class="buttonsAbsolutecontainer_right">
                    <img class="" (click)="moveSelected('up','left')"
                      [src]="'/assets/menu/'+ _theme +'/move-left-arrow.svg'" />
                      <img class="" (click)="moveAll('left')"
                        [src]="'/assets/menu/'+ _theme +'/move-all-left-arrow.svg'" />
                        <img class="" (click)="moveSelected('down', 'right')"
                          [src]="'/assets/menu/'+ _theme +'/move-down-arrow.svg'" />
                          <img class="" (click)="moveSelected('up', 'right')"
                            [src]="'/assets/menu/'+ _theme +'/move-up-arrow.svg'" />
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <ul class="selectedFieldsArray">
                                @for (field of selectedFields; track field; let i = $index) {
                                  <li>
                                    <span [class.item-selected]="field.isSelected"
                                    (click)="toggleSelection(field, 1)">{{field.title}}</span>
                                  </li>
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 stepsColPadding">
                    <h2 class="listboxTitle listboxTitle_right">Preview</h2>
                    <div class="bordered_sections_special_small minHeightSection">
                      <div class="row">
                        <div class="col-6">
                          <div class="row">
                            <div class="col-12">
                              <h2 class="previewsectionTitle">select mobile software</h2>
                            </div>
                            @for (mobile of _mobileDevices; track mobile) {
                              <div class="col-12">
                                <div class="wrap">
                                  <input type="radio" [formControl]="_mobileDeviceSelected"
                                    name="mobileDeviceSelected" [value]="mobile.key" kendoRadioButton />
                                    <label class="k-radio-label srLabel">{{mobile.name}}</label>
                                  </div>
                                </div>
                              }
                              <div class="col-12">
                                <h2 class="previewsectionTitle margin-top-10">select mobile type</h2>
                              </div>
                              @for (mobileType of _mobileDeviceTypes; track mobileType) {
                                <div class="col-12">
                                  <div class="wrap">
                                    <input type="radio" [formControl]="_mobileDeviceTypeSelected"
                                      name="mobileDeviceTypeSelected" [value]="mobileType.key"
                                      kendoRadioButton />
                                      <label class="k-radio-label srLabel">{{mobileType.name}}</label>
                                    </div>
                                  </div>
                                }
                                <div class="col-12">
                                  <button (click)="_onMobileImagePreview()" class="buttonDefaultStyle" kendoButton>
                                    <span><img [src]="'/assets/menu/'+ _theme +'/view-report-icon.svg'" /></span>
                                    <span>Preview</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-6 centeredImageContainerRow" [class]="_mobileImageClass">
                              <div class="imageDisplayContainer">
                                <img class="phoneImage" [src]="'/assets/menu/'+ _theme +'/Phones/' + _mobileImageSrc" />
                              </div>
                              <div class="absoluteContentContaainer">
                                @if (_buttonPreviewClicked) {
                                  <div class="contentRelativeContainer">
                                    <div class="transactionTitleAbsolute">{{_selectedTransactionId.name}}</div>
                                    <div class="appcontentDisplayContainer">
                                      @for (field of selectedFields; track field; let i = $index) {
                                        <div class="fullWidthDiv row-height">
                                          <label class="NewlabelGroupInsideimage">{{field.title}}</label>
                                          <input type="text" class="k-textbox insideImageInput" />
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        @if (_invalidForm) {
                          <asap-forms-validation-summary [form]="_form" [page]="'mobileAppGroups'">
                          </asap-forms-validation-summary>
                        }
                      </div>
                    </div>
                  </form>
                </kendo-window>
              }
